import React from 'react';
import { TitleWrapper } from './Title.styled';

const Title = ({ title, context }) => {
  return (
    <TitleWrapper data-testid={`test_title_${context}`}>
      {title}
    </TitleWrapper>
  )
}

export default Title;
